import { Splide, SplideProps } from "@splidejs/react-splide";
import { useMemo, useRef } from "react";

type Props = {
  additionalOptions?: Partial<SplideProps>;
};

const SLIDER_OPTIONS: Partial<SplideProps> = {
  options: {
    direction: "ltr",
    snap: true,
    pagination: false,
    autoHeight: true,
    autoWidth: true,
    width: "100%",
  },
};

const useManageAttributeCarousel = ({ additionalOptions }: Props) => {
  const splideRef = useRef<Splide>(null);

  const expandedSliderOptions = useMemo(
    () => ({
      options: {
        ...SLIDER_OPTIONS.options,
        ...additionalOptions?.options,
        ...{
          arrows:
            !!splideRef?.current?.splide?.Components?.Layout?.isOverflow(),
        },
      },
    }),
    [additionalOptions]
  );

  return { splideRef, expandedSliderOptions };
};

export default useManageAttributeCarousel;
